// Monthly buckets for the admin dashboard growth chart: player signups
// (userProfiles.createdAt) alongside tournament start dates.

export const toDate = (v) => {
  if (!v) return null;
  const d = typeof v.toDate === 'function' ? v.toDate() : new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
};

const monthKey = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;

/**
 * @param {Array} joinDates   raw createdAt values (ISO strings, Timestamps, or empty)
 * @param {Array} tournaments tournament docs with name + startDate
 * @param {Object} opts       { months: number|null (null = since first event), now: Date }
 */
export const buildMonthlyGrowth = (
  joinDates,
  tournaments,
  { months = 12, now = new Date() } = {}
) => {
  const joins = joinDates.map(toDate);
  const dated = joins.filter(Boolean);
  const undated = joins.length - dated.length;
  const events = tournaments
    .map((t) => ({ id: t.id, name: t.name, start: toDate(t.startDate) }))
    .filter((t) => t.start);

  const end = new Date(now.getFullYear(), now.getMonth(), 1);
  let start;
  if (months) {
    start = new Date(end.getFullYear(), end.getMonth() - (months - 1), 1);
  } else {
    const firsts = [...dated, ...events.map((e) => e.start)].filter((d) => d <= now);
    const first = firsts.length ? new Date(Math.min(...firsts)) : end;
    start = new Date(first.getFullYear(), first.getMonth(), 1);
  }

  const buckets = [];
  const byKey = {};
  for (let d = new Date(start); d <= end; d = new Date(d.getFullYear(), d.getMonth() + 1, 1)) {
    const bucket = { key: monthKey(d), date: d, joins: 0, total: 0, tournaments: [] };
    buckets.push(bucket);
    byKey[bucket.key] = bucket;
  }

  // Players already registered before the window (plus undated profiles,
  // which predate createdAt tracking) seed the running total.
  let running = undated;
  dated.forEach((d) => {
    const b = byKey[monthKey(d)];
    if (b) b.joins += 1;
    else if (d < start) running += 1;
  });
  buckets.forEach((b) => {
    running += b.joins;
    b.total = running;
  });

  events
    .sort((a, b) => a.start - b.start)
    .forEach((e) => {
      const b = byKey[monthKey(e.start)];
      if (b) b.tournaments.push(e);
    });

  return { buckets, undated };
};
